const textPattern = /^[a-zA-Z0-9 ]*$/
const numberPattern = /^\d+$/
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})(\/[\w.-]*)*\/?$/
const phonePattern = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/
const forbiddenPatterns = /[!@#$%^&,*()\-/]/
const datePattern = /^(0[1-9]|[12][0-9]|3[01])-(1[0-2]|[1-9])-\d{4}$/

export const noInvalidStrings = (value) => !forbiddenPatterns.test(value)
export const validateText = (value) => !value || textPattern.test(value)
export const validateNumber = (value) => !value || numberPattern.test(value)
export const validateEmail = (value) => !value || emailPattern.test(value)
export const validateUrl = (value) => !value || urlPattern.test(value)
export const validatePhone = (value) => !value || phonePattern.test(value)
export const validateDate = (value) => !value || datePattern.test(value)